/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Mdx } from '@ta-interaktiv/contentbricks'
import * as config from './config'
import { ScrollTracking } from 'components/scrolltracking'
import Drawer from 'components/drawer'
import { browserCheck } from '@ta-interaktiv/browsercheck'

const ARTICLE_ID = '19483314'
const ADDITIONAL_SHARES = 326
config.chapters.sort((a, b) => {
  return a.sort - b.sort
})
export function AppComponent() {
  const [activeIndex, setActiveIndex] = React.useState([])

  // handle Funktion
  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    // const newIndex = activeIndex === index ? -1 : index
    // this.setState({ activeIndex: newIndex })
    const openIndex = activeIndex.indexOf(index)
    console.log('openIndex: ', openIndex)
    if (openIndex === -1) {
      setActiveIndex([...activeIndex, index])
    } else {
      console.log('activeIndex', openIndex, activeIndex)
      const newArray = activeIndex.filter(idx => idx !== index)
      setActiveIndex(newArray)
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
      <ThemeSwitch />
      <ScrollTracking />
      <header className='ui vertical  fitted segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Wie sich das Coronavirus verbreitet — und was gegen Aerosole hilft
              <div className='sub header'>
                Kann sich das Coronavirus über die Luft verbreiten? Reicht es
                schon für eine Ansteckung, wenn ich an einem Infizierten
                vorbeigehe? Die wichtigsten Fragen und Antworten zu den
                Übertragungswegen von Sars-CoV-2.
              </div>
            </div>
          </h1>
        </div>
      </header>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='metainfo'>
            <div className='author'>
              <nobr>Marc Brupbacher</nobr>, <nobr>Sebastian Broschinski</nobr>{' '}
              und <nobr>Mathias Lutz</nobr>
            </div>
            <div className='updated'>Aktualisiert am 17. November 2020</div>
          </div>
          <Mdx file={require('text/0-intro.mdx')} />
        </div>
      </div>
      <div
        className='ui vertical segment'
        style={{ paddingTop: browserCheck.isMobile ? '0' : '1em' }}
      >
        <div className='ui text container'>
          <div className='akkordeon'>
            {config.chapters.map((c, index) => (
              <div key={c.id} className={'qaList' + index} id={c.id}>
                <Drawer title={c.name}>
                  <Mdx file={require('text/' + c.text + '.mdx')} />
                </Drawer>
              </div>
            ))}
          </div>
          {/*
          <Accordion fluid styled>
            {config.chapters.map((c, index) => (
              <div key={c.id} className={'qaList' + index} id={c.id}>
                <Tab
                  activeIndex={activeIndex}
                  index={index}
                  handleClick={handleClick}
                  title={c.name}
                  // flag={q.n}
                  articleId={ARTICLE_ID}
                >
                  <Mdx file={require('text/' + c.text + '.mdx')} />
                </Tab>
              </div>
            ))}
          </Accordion>
            */}
        </div>
      </div>

      <Footer
        additionalShares={ADDITIONAL_SHARES}
        articleId={ARTICLE_ID}
        credits={[
          [
            'Konzept und Umsetzung',
            'Marc Brupbacher Sebastian Broschinski und Mathias Lutz'
          ]
        ]}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
      >
        <div className='ui vertical relaxed segment'>
          <div className='ui container'></div>
        </div>
      </Footer>
    </div>
  )
}
